<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">{{routeName}}</div>
                </div>
                <div class="col-md-3 offset-md-3 text-right center">
                    <button type="submit" class="btn btn-primary btn-fill"
                            @click="create()">Create Corporation</button>
                </div>
            </div>
            <div class="table-responsive text-center">
                <l-table class="table table-light table-bordered table-hover"
                         :columns="corporations.columns" :data="corporations.data">
                    <template slot="table-row" v-if="corporations.data.length">
                        <tr v-for="(item, index) in corporations.data" :key="index" :class="{'inactive': item.active !== '1'}">
                            <!--td><img :src="item.smallImage" alt="corporation-image" class="table-thumbnail"></td-->
                            <td>{{item.name}}</td>
                            <td>{{item.welcomeMessage}}</td>
                            <td>{{item.button_label_01}}</td>
                            <td>{{item.invitation_code}}</td>
                            <td>{{item.accountLimit}}</td>
                          <td><span v-if="item.enableCorporatePage" class="badge badge-success">Yes</span><span v-else class="badge badge-danger">No</span></td>
                            <td>
                                <span class="badge badge-success" v-if="item.active == '1'"> Active </span>
                                <span class="badge badge-danger" v-else> Inactive </span>
                            </td>
                            <td>
                                <div class="btn-group" role="group">
                                    <button class="btn btn-secondary btn-sm" @click="view(item)" v-tooltip.top-center="tooltips.view"><i class="fa fa-eye"></i></button>
                                    <button class="btn btn-info btn-sm" @click="edit(item)" v-tooltip.top-center="tooltips.edit"><i class="fa fa-edit"></i></button>
                                    <button v-if="item.active == '1'" class="btn btn-danger btn-sm" @click="statusChange(item, true)" v-tooltip.top-center="tooltips.delete"><i class="fa fa-toggle-off"></i></button>
                                    <button class="btn btn-success btn-sm" v-else @click="statusChange(item, false)" v-tooltip.top-center="tooltips.activate"><i class="fa fa-toggle-on"></i></button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const columns = ['Name', 'Welcome Message', 'Button Label', 'Type', 'Limit', 'Enable Corporate Page', 'Status', 'Operations'];
    export default {
        name: 'Corporations',
        components: {
            LTable,
        },
        data() {
        return {
            tooltips: {
                view: 'View',
                edit: 'Edit',
                delete: 'Inactivate',
                activate:'Activate',
            },
            corporations: {
                columns: [...columns],
        data: []
    }
    }
    },
    methods: {
        fetch () {
            this.$store.dispatch('FETCH_CORPORATIONS')
                    .then((res) => {
                        this.corporations.data = res;
                        console.log("this.corporations.data : ", this.corporations.data);
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
        },
        view(item){
            this.$store.commit('SET_SELECTED_CORPORATION', item);
            this.$router.push({ name: 'Corporation Details', params: { id:  item.corporationId}})
        },
        edit(item){
            this.$store.commit('SET_SELECTED_CORPORATION', item);
            this.$router.push({ name: 'Edit Corporation', params: { id: item.corporationId}});
        },
        create(){
            this.$router.push({ name: 'Create Corporation'})
        },
        statusChange(item, boolean){
            this.$store.dispatch('DELETE_CORPORATION', {corporationId: item.corporationId, isDelete: boolean})
                    .then((res) => {
                        console.log("DELETE_CORPORATION API res : ", res);
                        this.fetch();
                    })
                    .catch(err => {
                        console.log("DELETE_CORPORATION API error : ", err);
                    })
        },
        capitalizeFirstLetter (string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        },
    },
    created() {
        this.fetch();
    },
    computed:{
        routeName () {
            const {name} = this.$route;
            return this.capitalizeFirstLetter(name);
        }
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Corporations/Corporations.vue